import "./drawer.css";
import DrawerHeader from "./DrawerHeader";

interface DrawerNoFooterProps {
  title: string;
  subtitle: string;
  openDrawer: boolean;
  onClose?: () => void;
  children: React.ReactNode;
}

export const DrawerNoFooter = ({
  title,
  subtitle,
  openDrawer,
  onClose,
  children,
}: DrawerNoFooterProps) => {
  return (
    <div className={`backdrop ${openDrawer ? "visible" : "hidden"}`}>
      <div className={`gx-app-drawer ${openDrawer ? "open" : ""}`}>
        {/* Drawer Header */}
        <DrawerHeader
          title={title}
          subtitle={subtitle}
          handleClose={onClose ?? (() => {})}
        />

        {/* Drawer Body */}
        <div className="drawer-content">
          {children ? <>{children}</> : <>No Items Found</>}
        </div>
      </div>
    </div>
  );
};
